import { v4 } from 'uuid';
import _ from 'lodash';

import PeriodSunburstTooltip from '../../components/tooltip/period/PeriodSunburstTooltip';

const toPeriodSunburstConfig = (
  data,
  options,
  showCalcTotal,
  fromDashboard = false,
  showSort,
  single
) => {
  let dataVar = data;
  // создается массив id для каждого ивента
  const ids = dataVar.map(() => v4());
  // присваиваются id для тех данных где его нету(актуально для revenue и usage)
  dataVar = dataVar.map((d, index) => ({ ...d, id: d.id === '' ? ids[index] : d.id }));
  const categoryNodes = dataVar.flatMap(({ id, categories }) =>
    categories.map((category) => ({
      id: v4(),
      parent: id,
      name: category,
    }))
  );

  const periodSunburstChartConfig = {
    title: {
      text: dataVar
        .map((event) =>
          ids.includes(event.id) ? event.name : `${event.id}.${event.name} (${event.periods}) `
        )
        .join(' '),
      align: 'center',
      verticalAlign: 'bottom',
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
    },
    chart: {
      events: {
        redraw: (chart) => {
          const chartVar = chart;
          if (chartVar.series?.[0]?.options?.animation) {
            chartVar.series[0].options.animation = false;
          }
        },
      },
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: [
            'printChart',
            'separator',
            'downloadPNG',
            'downloadJPEG',
            'downloadPDF',
            'downloadSVG',
          ],
        },
        Fullscreen: {
          verticalAlign: 'bottom',
          align: 'left',
          text: 'full screen',
          onclick() {
            this.fullscreen.toggle();
          },
        },
      },
    },
    series: [
      {
        tooltip: {
          pointFormatter() {
            const parentValue = _.sum(
              this.series.data.filter((x) => x.parent === this.parent).map((obj) => obj.value)
            );
            const parentName = (this.series.data.find((x) => x.id === this.parent) || {}).name;
            return PeriodSunburstTooltip(parentValue, parentName, this, dataVar, single);
          },
        },
        type: 'sunburst',
        data: [
          {
            id: -1,
            parent: '',
            name: '',
          },
          ...dataVar.map(({ name, id }) => ({
            id,
            parent: -1,
            name,
          })),
          ...dataVar.flatMap(({ series, id: rootId }) =>
            series.flatMap(({ data: dataParam, name }) =>
              dataParam.map(([category, value]) => ({
                id: v4(),
                parent:
                  name === 'undefined'
                    ? rootId
                    : categoryNodes.find(
                        ({ parent, name: nameParam }) =>
                          String(parent) === String(rootId) &&
                          String(nameParam) === String(category)
                      ).id,
                name: name === 'undefined' ? String(category) : String(name),
                value,
              }))
            )
          ),
          ...categoryNodes,
        ],
        allowDrillToNode: true,
        cursor: 'pointer',
        dataLabels: {
          style: {
            textOutline: 'none',
            textOverflow: 'ellipsis',
          },
          format: '{point.name}',
          filter: {
            property: 'innerArcLength',
            operator: '>',
            value: 16,
          },
        },
        levels: [
          {
            level: 1,
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: 'outerArcLength',
                operator: '>',
                value: 64,
              },
            },
          },
          {
            level: 2,
            colorByPoint: true,
          },
          {
            level: 3,
            colorVariation: {
              key: 'brightness',
              to: -0.5,
            },
          },
        ],
      },
    ],
  };

  if (fromDashboard) {
    delete periodSunburstChartConfig.exporting.buttons.Fullscreen;
  }

  return periodSunburstChartConfig;
};

export default toPeriodSunburstConfig;
